import { render, staticRenderFns } from "./InsectPestsDetail.vue?vue&type=template&id=8b6da670&scoped=true"
import script from "./InsectPestsDetail.vue?vue&type=script&lang=ts"
export * from "./InsectPestsDetail.vue?vue&type=script&lang=ts"
import style0 from "./InsectPestsDetail.vue?vue&type=style&index=0&id=8b6da670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6da670",
  null
  
)

export default component.exports